import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './components/ThemeProvider';
import { Toaster } from './components/ui/sonner';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import PlaygroundPage from './pages/PlaygroundPage';
import './App.css';

function App() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="efcore-theme">
      <Router>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/playground" element={<PlaygroundPage />} />
          </Routes>
        </Layout>
        <Toaster position="top-right" />
      </Router>
    </ThemeProvider>
  );
}

export default App;
